import { render } from "./DateField.vue?vue&type=template&id=675636fb&ts=true"
import script from "./DateField.vue?vue&type=script&lang=ts"
export * from "./DateField.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__